import React from "react";
import { StyledSVG, Wrapper } from "./IconStyle";
import { useLocation } from "react-router";

export const routeActiveQM = ["quality-management"];

const QMIcon = () => {
  const { pathname } = useLocation();
  return (
    <Wrapper>
      {routeActiveQM.some((item) => item.includes(pathname.split("/")[1])) ? (
        <StyledSVG
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.1541 1.8335H8.84578C7.89245 1.8335 7.11328 2.6035 7.11328 3.55683V4.4185C7.11328 5.37183 7.88328 6.14183 8.83661 6.14183H13.1541C14.1074 6.14183 14.8774 5.37183 14.8774 4.4185V3.55683C14.8866 2.6035 14.1074 1.8335 13.1541 1.8335Z"
            fill="#20A2A2"
          />
          <path
            d="M15.8034 4.41819C15.8034 5.87569 14.6117 7.06736 13.1542 7.06736H8.84587C7.38837 7.06736 6.1967 5.87569 6.1967 4.41819C6.1967 3.90486 5.6467 3.58403 5.18837 3.82236C3.89587 4.50986 3.01587 5.87569 3.01587 7.44319V16.069C3.01587 18.324 4.85837 20.1665 7.11337 20.1665H14.8867C17.1417 20.1665 18.9842 18.324 18.9842 16.069V7.44319C18.9842 5.87569 18.1042 4.50986 16.8117 3.82236C16.3534 3.58403 15.8034 3.90486 15.8034 4.41819ZM14.0617 11.669L10.395 15.3357C10.2575 15.4732 10.0834 15.5374 9.9092 15.5374C9.73504 15.5374 9.56087 15.4732 9.42337 15.3357L8.04837 13.9607C7.78254 13.6949 7.78254 13.2549 8.04837 12.989C8.3142 12.7232 8.7542 12.7232 9.02004 12.989L9.9092 13.8782L13.09 10.6974C13.3559 10.4315 13.7959 10.4315 14.0617 10.6974C14.3275 10.9632 14.3275 11.4032 14.0617 11.669Z"
            fill="#20A2A2"
          />
        </StyledSVG>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.90921 15.5374C9.73504 15.5374 9.56087 15.4733 9.42337 15.3358L8.04837 13.9608C7.78254 13.6949 7.78254 13.2549 8.04837 12.9891C8.31421 12.7233 8.75421 12.7233 9.02004 12.9891L9.90921 13.8783L13.09 10.6974C13.3559 10.4316 13.7959 10.4316 14.0617 10.6974C14.3275 10.9633 14.3275 11.4033 14.0617 11.6691L10.395 15.3358C10.2667 15.4733 10.0834 15.5374 9.90921 15.5374Z"
            fill="#454F5B"
          />
          <path
            d="M12.8334 6.18766H9.16671C8.28671 6.18766 6.64587 6.18766 6.64587 3.66683C6.64587 1.146 8.28671 1.146 9.16671 1.146H12.8334C13.7134 1.146 15.3542 1.146 15.3542 3.66683C15.3542 4.54683 15.3542 6.18766 12.8334 6.18766ZM9.16671 2.521C8.25921 2.521 8.02087 2.521 8.02087 3.66683C8.02087 4.81266 8.25921 4.81266 9.16671 4.81266H12.8334C13.9792 4.81266 13.9792 4.57433 13.9792 3.66683C13.9792 2.521 13.7409 2.521 12.8334 2.521H9.16671Z"
            fill="#454F5B"
          />
          <path
            d="M13.75 20.8541H8.25C3.09833 20.8541 2.0625 18.4891 2.0625 14.6666V9.16656C2.0625 4.98656 3.575 3.19906 7.29667 3.00656C7.6725 2.98823 8.0025 3.2724 8.02083 3.6574C8.03917 4.0424 7.74583 4.35406 7.37 4.3724C4.76667 4.51906 3.4375 5.29823 3.4375 9.16656V14.6666C3.4375 18.0582 4.10667 19.4791 8.25 19.4791H13.75C17.8933 19.4791 18.5625 18.0582 18.5625 14.6666V9.16656C18.5625 5.29823 17.2333 4.51906 14.63 4.3724C14.2542 4.35406 13.9608 4.02406 13.9792 3.64823C13.9975 3.2724 14.3183 2.97906 14.7033 2.9974C18.425 3.19906 19.9375 4.98656 19.9375 9.1574V14.6574C19.9375 18.4891 18.9017 20.8541 13.75 20.8541Z"
            fill="#454F5B"
          />
        </svg>
      )}
    </Wrapper>
  );
};

export default QMIcon;
